import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { ImageUploadService } from 'app/shared/services/image-upload/image-upload.service';
import { Toast } from 'app/shared/components/toast/toast.service';
import { Session } from 'app/shared/services/session/session.service';
import { InlineSpinnerLoaderComponent } from 'app/shared/components/inline-spinner-loader/inline-spinner-loader.component';
import { ImageService } from '../../services/image/image.service';

@Component({
  selector: 'tog-image-library',
  templateUrl: './image-library.component.html',
  styleUrls: ['./image-library.component.scss']
})
export class ImageLibraryComponent implements OnInit {
  preventCollapseAnimation: boolean = true; // keeps shelf from animating on initial load
  preventShowAnimation: boolean = true;
  expanded: boolean = false;
  hidden: boolean = false;
  content: any[] = [];

  @Input() cropperName: string;

  @Output() imageSelected: EventEmitter<string> = new EventEmitter<string>();
  @Output() expand = new EventEmitter();

  @ViewChild('previewSpinner') previewSpinner: InlineSpinnerLoaderComponent;

  constructor(private _ius: ImageUploadService,
              private _toast: Toast,
              private _session: Session,
              public imageService: ImageService) {}

  ngOnInit() {
    this.previewSpinner.show();
    this._session.user()
    .then(() => {
      return this._ius.getAllAWSImagesByApp(this._session.selectedAppSysName);
    })
    .then(response => {
      if (response) this.content = response.map((image) => this.createContentListObject(image));
      this.attemptToSelectOriginalImage();
      this.previewSpinner.hide();
    });
  }

  attemptToSelectOriginalImage() {
    // Select the original image
    let originalImageName = this.imageService.getOriginalName(this.cropperName);
    if (originalImageName) {
      let sanitizedUrl = originalImageName.split('%2F').pop();
      sanitizedUrl = sanitizedUrl.split('-');
      sanitizedUrl.pop();
      sanitizedUrl = sanitizedUrl.join('-');
      let originalImage = this.content.filter(content => content.image.indexOf(sanitizedUrl) > -1);
      if (sanitizedUrl.length && originalImage.length) {
        this.selectImage(originalImage[0]);
        return;
      }
    }
    // Fallback
    this.selectImage(this.content[0]);
  }

  createContentListObject(imageUrl: string) {
    let splitUrl = imageUrl.split('/');
    let originalName = splitUrl.pop();
    return { selected: false, image: imageUrl, originalName: originalName };
  }

  toggleLibraryExpansion(forceDisplayMode?: string) {
    this.expanded = !this.expanded;
    this.expand.emit(this.expanded);
  }

  selectImage(content: any) {
    if (this.expanded) {
      this.content.splice(this.content.indexOf(content), 1);
      this.content.unshift(content);
      this.toggleLibraryExpansion();
    }
    if (content) {
      content.selected = true;
      if (content.selected) {
        // deselects all other images
        this.content.forEach((image) => {
          if (image != content) {
            image.selected = false;
          }
        });
        this.imageSelected.emit(content.image);
        if (this.cropperName) this.imageService.setImageURLToBeCropped(content.image, this.cropperName);
        this.expanded = false;
      }
    }
  }

  maxFileSizeExceeded() {
    this._toast.error('Image is too large. Please select an image less than 1MB.');
  }

  uploadImage(image: File) {
    this._ius.uploadOriginalImage(this._session.selectedAppSysName, image)
    .then((res) => {
      this.content.unshift(this.createContentListObject(res));
      this.selectImage(this.content[0]);
    });
  }

  deleteImage(e: any, content: any) {
    e.stopPropagation();
    console.log('staging ' + content.image + ' for deletion');
  }
}



// WEBPACK FOOTER //
// /app/src/app/shared/components/image-library/image-library.component.ts